import script from "./IntakeOpsReview.vue?vue&type=script&setup=true&lang=js"
export * from "./IntakeOpsReview.vue?vue&type=script&setup=true&lang=js"

import "./IntakeOpsReview.vue?vue&type=style&index=0&id=05b41fe9&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-05b41fe9"]])

export default __exports__